import { FieldDatatype } from '../../datatype/Datatype';
import { IBaseConditionOperatorType } from './IConditionOperator';
import { ConditionOperatorDefinedType } from './repository/ConditionOperatorDefined.type';
import { ConditionOperatorEqualsType } from './repository/ConditionOperatorEquals.type';
import { ConditionOperatorGreaterType } from './repository/ConditionOperatorGreater.type';
import { ConditionOperatorInType } from './repository/ConditionOperatorIn.type';
import { ConditionOperatorLowerType } from './repository/ConditionOperatorLower.type';
import { ConditionOperatorNotDefinedType } from './repository/ConditionOperatorNotDefined.type';
import { ConditionOperatorNotEqualsType } from './repository/ConditionOperatorNotEquals.type';
import { ConditionOperatorNotInType } from './repository/ConditionOperatorNotIn.type';
import { ConditionOperatorAtleastOneType } from './repository/array/ConditionOperatorAtleastOne.type';
import { ConditionOperatorContainsNoOne } from './repository/array/ConditionOperatorContainsNoOne.type';
import { ConditionOperatorContainsOne } from './repository/array/ConditionOperatorContainsOne.type';
import { ConditionOperatorCountEquals } from './repository/array/ConditionOperatorCountEquals.type';
import { ConditionOperatorCountGreater } from './repository/array/ConditionOperatorCountGreater.type';
import { ConditionOperatorCountLower } from './repository/array/ConditionOperatorCountLower.type';
import { ConditionOperatorEmptyItemType } from './repository/array/ConditionOperatorEmptyItem.type';
import { ConditionOperatorEveryOneType } from './repository/array/ConditionOperatorEveryOne.type';
import { ConditionOperatorNotEmptyItemType } from './repository/array/ConditionOperatorNotEmptyItem.type';

export const OperatorsRepository = {
  types: [
    // Definizione
    ConditionOperatorNotDefinedType,
    ConditionOperatorDefinedType,
    // Confronto con valori
    ConditionOperatorEqualsType,
    ConditionOperatorNotEqualsType,
    ConditionOperatorGreaterType,
    ConditionOperatorLowerType,
    // Confronto con liste
    ConditionOperatorNotInType,
    ConditionOperatorInType,
    // Array (oggetti)
    ConditionOperatorAtleastOneType,
    ConditionOperatorEveryOneType,
    // Array (plain)
    ConditionOperatorContainsOne,
    ConditionOperatorContainsNoOne,
    // Conteggio
    ConditionOperatorCountEquals,
    ConditionOperatorCountGreater,
    ConditionOperatorCountLower,
    ConditionOperatorNotEmptyItemType,
    ConditionOperatorEmptyItemType,
  ] as IBaseConditionOperatorType[],
  forField: (field: FieldDatatype) => {
    return OperatorsRepository.types.filter(operator =>
      operator.allowsField(field),
    );
  },
  get: (type: string | null | undefined) => {
    return type == null
      ? null
      : OperatorsRepository.types.find(operator => operator.code === type);
  },
};
